import { BrowserRouter, Route, Routes } from "react-router-dom";
import Abstracts from "./components/abstracts";
import Committees from "./components/committees";
import Contact from "./components/contact";
import Footer from "./components/footer";
import Home from "./components/home";
import Keynotes from "./components/keynotes";
import Navbar from "./components/navbar";
import Registration from "./components/registration";
import ScrollToTop from "./components/ScrollToTop";
import Success from "./components/success";
import Error from "./components/error";


function App() {
  return (
    <>
      <BrowserRouter basename="/vetomac2023">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/abstracts" element={<Abstracts />} />
          <Route path="/keynotes" element={<Keynotes />} />
          <Route path="/committees" element={<Committees />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/success" element={<Success />} />
          <Route path="/error" element={<Error />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
